import { render } from "./deviceType.vue?vue&type=template&id=2b3b2c88&scoped=true"
import script from "./deviceType.vue?vue&type=script&lang=js"
export * from "./deviceType.vue?vue&type=script&lang=js"

import "./deviceType.vue?vue&type=style&index=0&id=2b3b2c88&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3b2c88"]])

export default __exports__